import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LogoLoop from "./animatedComponents/LogoLoop";
import { imageLogos, contactInfo, socialLinks } from "../constants";

gsap.registerPlugin(ScrollTrigger);

const ContactSection = () => {
  return (
    <>
      {/* Logo Loop */}
      {/* <div className="h-[140px] lg:h-[180px] relative overflow-hidden mt-10 ">
        <LogoLoop
          logos={imageLogos}
          speed={120}
          direction="left"
          logoHeight={48}
          gap={40}
          pauseOnHover
          scaleOnHover
          fadeOut
          fadeOutColor="#f5f5f5"
          ariaLabel="Technology partners"
        />
      </div> */}
      <section id="contact" className="relative bg-[#f5f5f5]">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left: Contact Info & Social Links */}
            <div className="space-y-8">
              {/* Contact Information */}
              <div>
                <h3 className="text-2xl font-bold text-foreground mb-6 font-orbitron">
                  Get In Touch
                </h3>
                <div className="space-y-4">
                  {contactInfo.map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      target="_blank"
                      className="contact-item flex items-center space-x-4 p-4 rounded-lg hover:bg-secondary/50 transition-colors duration-300"
                    >
                      <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center hover:scale-110 hover:bg-primary/20">
                        <item.icon className="w-6 h-6 text-primary" />
                      </div>
                      <div className="max-w-[200px] md:max-w-[600px]">
                        <p className="text-sm text-muted-foreground ">
                          {item.label}
                        </p>
                        <p className="text-foreground font-medium text-md font-poppins">
                          {item.text}
                        </p>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Links */}
              <div>
                <h3 className="text-2xl font-bold text-foreground mb-6 font-orbitron">
                  Follow Us
                </h3>
                <div className="flex space-x-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      className="social-icon w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center text-primary transition-all duration-300 hover:scale-110 hover:bg-primary/20"
                      aria-label={social.label}
                    >
                      <social.icon className="w-7 h-7" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Background decorations */}
        <div className="absolute top-20 left-10 w-2 h-2 bg-primary rounded-full animate-twinkle opacity-60" />
        <div
          className="absolute bottom-32 right-20 w-1.5 h-1.5 bg-primary rounded-full animate-twinkle opacity-70"
          style={{ animationDelay: "2s" }}
        />
        <div
          className="absolute top-1/2 left-1/4 w-1 h-1 bg-primary rounded-full animate-twinkle opacity-80"
          style={{ animationDelay: "4s" }}
        />
      </section>
    </>
  );
};

export default ContactSection;
